module.exports = __webpack_public_path__ + "media/rot1.45f17bf6.mp4";